// extracted by css-extract-rspack-plugin
export default {"cls1":"EdgePill-cls1_Lze","cls2":"EdgePill-cls2_zII EdgePill-cls1_Lze"};